import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../../graphql-client/graphql/_global/fragments/generated/CompleteImages';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectDetailsFragment = { __typename?: 'Project', id: string, archivedAt?: string | null, description?: string | null, fileCount: number, imageUrl?: string | null, insertedAt: string, isWorkfront?: boolean | null, mountedStorageStatus?: Types.MountedStorageStatus | null, name: string, notificationsEnabled?: boolean | null, private: boolean, rootAssetId: string, storage: number, totalCount?: number | null, updatedAt?: string | null, workfrontProjectLink?: string | null, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null };

export const ProjectDetails = /*#__PURE__*/ gql`
    fragment ProjectDetails on Project {
  id
  archivedAt
  description
  fileCount
  imageUrl
  images {
    ...CompleteImages
  }
  insertedAt
  isWorkfront
  mountedStorageStatus
  name
  notificationsEnabled
  private
  rootAssetId
  storage
  totalCount
  updatedAt
  workfrontProjectLink
  workspace {
    id
    name
  }
}
    ${CompleteImages}` as unknown as DocumentNode<ProjectDetailsFragment, unknown>;

        

        
export const useProjectDetailsFragment = (
  input: string | Omit<UseFragmentOptions<ProjectDetailsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectDetailsFragment>({
    fragment: ProjectDetails,
    fragmentName: 'ProjectDetails',
    ...options,
  });
};
  
        